module.exports = __webpack_public_path__ + "img/logo_white.bb11dcb6.png";